import { ReactNode } from 'react';
import { cn } from '../../lib/cn.js';

interface TableToolbarProps {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
}

/**
 * Slot-based toolbar that sits inside a table card.
 * Left slot: search + mode chips
 * Right slot: date range + row count + column manager + filter + kebab
 */
export function TableToolbar({ left, right, className }: TableToolbarProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 flex-wrap px-4 py-3 border-b border-border bg-white relative z-20',
        className
      )}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0 flex-wrap">
        {left}
      </div>
      {right && (
        <div className="flex items-center gap-1.5 flex-shrink-0 flex-wrap">
          {right}
        </div>
      )}
    </div>
  );
}
